module.exports = __webpack_public_path__ + "img/personaje_1.b7c99106.png";